import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import WelcomeSidebar from "@/components/welcome/WelcomeSidebar";
import ContactModal from "@/components/welcome/ContactModal";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function SiteLayout() {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setCollapsed(isMobile);
  }, [isMobile]);

  return (
    <div className="min-h-screen bg-background">
      <WelcomeSidebar collapsed={collapsed} onContact={() => setModalOpen(true)} />
      <main className={`transition-all duration-300 ${collapsed ? "ml-16" : "ml-16 lg:ml-60"}`}>
        <Outlet />
      </main>
      <ContactModal open={modalOpen} onOpenChange={setModalOpen} topic="Let's talk" />
    </div>
  );
}